import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Response, Headers } from "@angular/http";
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { serverConfig, finixConfig } from '../../app/settings.config';

declare const Finix: any;

@Injectable()
export class FinixServiceProvider {

  constructor(public http: HttpClient, public httpOld: Http, public afAuth: AngularFireAuth) {

  }

  newcard(cardToken, orderKey, locInfo, loyality, saveCard) {
    var promise = new Promise(async (resolve, reject) => {
      var _token = await this.getNewToken();
      let _user = await this.getAuthUser();
      var _uid = (_user as any).uid;
      var _clientId = localStorage.getItem('clientId') || serverConfig.clientId;
      var _body = {
        "uid": _uid,
        "clientId": _clientId,
        "orderId": orderKey,
        "token": cardToken,
        "saveCard": saveCard,
        "locId": localStorage.getItem('selectedCity')
      }
      if(loyality){ _body['loyality'] = loyality }
      //TODO: generate fraud session token
      var _fraudId = await this.generateFraudId(locInfo.finixMerchantId);
      if (_fraudId) { _body['fraudId'] = _fraudId; }
      // console.log('newCard Data:', _body);
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + _token
        })
      }
      this.http.post(serverConfig.baseUrl + '/finixApp/newCard', _body, httpOptions)
        .subscribe(res => {
          resolve(res)
        }, err => { reject(err) });
    });
    return promise;
  }

  savedCardSale(cardToken, orderId, locInfo, loyality, fraudId?) {
    var promise = new Promise(async (resolve, reject) => {
      var _token = await this.getNewToken();
      let _user = await this.getAuthUser();
      var _uid = (_user as any).uid;
      var _clientId = localStorage.getItem('clientId') || serverConfig.clientId;
      var _body = {
        "uid": _uid,
        "loyality": loyality,
        "clientId": _clientId,
        "orderId": orderId,
        "token": cardToken,
        "locId": localStorage.getItem('selectedCity')
      }
      //TODO: generate fraud session token
      var _fraudId = await this.generateFraudId(locInfo.finixMerchantId);
      if (_fraudId) { _body['fraudId'] = _fraudId; }
      // console.log('savedCard Data:', _body);
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + _token
        })
      }
      this.http.post(serverConfig.baseUrl + '/finixApp/createSale', _body, httpOptions)
        .subscribe(res => {
          resolve(res)
        }, err => { 
          reject(err) 
        });
    });
    return promise;
  }

  generateFraudId(_finixMerchantId) {
    var promise = new Promise(async (resolve, reject) => {
    Finix.Auth(finixConfig.environment, _finixMerchantId, (sessionKey) => {
      // console.log('Test fraudId:', sessionKey);
      resolve(sessionKey)
    });
    });
    return promise;
  }

  getNewToken() {
    var promise = new Promise((resolve, reject) => {
      this.afAuth.auth.onAuthStateChanged(function (user) {
        if (user) {
          user.getIdToken(true).then(function (data) {
            resolve(data);
          }, error => {
            resolve(user.refreshToken);
          });
        }
      });
    });
    return promise;
  }

  async getAuthUser() {
    return new Promise((resolve, reject) => {
      this.afAuth.authState.take(1).subscribe(usr => {
        resolve(usr)
      }, err => reject(err))
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/finix-service/finix-service.ts